<template>
  <div v-if="showSection && sponsors.length > 0" class="sponsors-section mt-4">
    <article class="post-area single-blog">
      <div class="about-me">
        <div class="about-me-text my-0 mx-0 px-0 py-0">
          <h2 class="pt-0 mt-0">AKCIJO PODPIRAJO</h2>

          <!-- Simple display for 5 or fewer sponsors -->
          <div v-if="sponsors.length <= 5" class="sponsors-container">
            <template v-for="sponsor in sponsors">
              <a
                v-if="sponsor.link"
                :key="sponsor.id"
                :href="sponsor.link"
                target="_blank"
                rel="noopener noreferrer"
                class="sponsor-item"
                :title="sponsor.title"
                v-b-tooltip.hover
              >
                <img
                  :src="sponsor.imageUrl"
                  :alt="sponsor.title"
                  class="sponsor-logo"
                />
              </a>
              <span
                v-else
                :key="sponsor.id"
                class="sponsor-item"
                :title="sponsor.title"
                v-b-tooltip.hover
              >
                <img
                  :src="sponsor.imageUrl"
                  :alt="sponsor.title"
                  class="sponsor-logo"
                />
              </span>
            </template>
          </div>

          <!-- Carousel for more than 5 sponsors -->
          <div v-else class="sponsors-carousel-container">
            <VueSlickCarousel v-bind="carouselSettings" ref="carousel">
              <div v-for="sponsor in sponsors" :key="sponsor.id" class="sponsor-slide">
                <a
                  v-if="sponsor.link"
                  :href="sponsor.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="sponsor-item d-block text-center"
                  :title="sponsor.title"
                  v-b-tooltip.hover
                >
                  <img
                    :src="sponsor.imageUrl"
                    :alt="sponsor.title"
                    class="sponsor-logo"
                  />
                </a>
                <span
                  v-else
                  class="sponsor-item d-block text-center"
                  :title="sponsor.title"
                  v-b-tooltip.hover
                >
                  <img
                    :src="sponsor.imageUrl"
                    :alt="sponsor.title"
                    class="sponsor-logo"
                  />
                </span>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { db } from "@/main";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "SponsorsSection",
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      sponsors: [],
      showSection: true,
      carouselSettings: {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    };
  },
  async mounted() {
    await this.loadConfig();
    await this.loadSponsors();
  },
  methods: {
    async loadConfig() {
      try {
        const configSnapshot = await db.collection("config").get();
        if (!configSnapshot.empty) {
          const config = configSnapshot.docs[0].data();
          this.showSection = config.showSponsorsSection !== false;
        }
      } catch (error) {
        console.error("Error loading config:", error);
      }
    },

    async loadSponsors() {
      try {
        const snapshot = await db.collection("sponsors").get();

        this.sponsors = snapshot.docs
          .map(doc => {
            const data = doc.data();
            return {
              ...data,
              id: doc.id
            };
          })
          .sort((a, b) => (a.order || 0) - (b.order || 0));
      } catch (error) {
        console.error("Error loading sponsors:", error);
      }
    }
  }
};
</script>

<style lang="scss">
.sponsors-section {
  .single-blog {
    background: #fff;
  }

  .post-area .about-me .about-me-text {
    border-bottom: none !important;
    padding-bottom: 20px;
  }

  .sponsors-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    padding: 30px 20px;
    flex-wrap: wrap;
  }

  .sponsor-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease, opacity 0.2s ease;

    &:hover {
      transform: scale(1.05);
      opacity: 0.8;
    }
  }

  .sponsor-logo {
    max-height: 70px;
    max-width: 160px;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .sponsor-slide {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
  }

  // Carousel styling
  .sponsors-carousel-container {
    padding: 0 30px;

    ::v-deep .slick-prev,
    ::v-deep .slick-next {
      width: 30px;
      height: 30px;

      &:before {
        color: #6d5a3f;
        font-size: 24px;
      }
    }

    ::v-deep .slick-prev {
      left: -5px;
    }

    ::v-deep .slick-next {
      right: -5px;
    }

    ::v-deep .slick-dots {
      bottom: -25px;

      li button:before {
        color: #6d5a3f;
      }

      li.slick-active button:before {
        color: #59971f;
      }
    }
  }
}
</style>
